import React, { Component, Fragment, useState } from 'react';
import Select, { Option } from '../../../common/component/Select';
import Wrapper from '../../../common/component/Wrapper';
import useGetHomestayisActive from './UseGetHomestayisActive';

const RenderHomestayisActive = ({
    onChangedHomestay = () => { },
    defaultHomestayId = 0,
    defaultOptionLabel = "Vui lòng chọn"
}) => {
    const [homestaySearch, setHomestaySearch] = useState(defaultHomestayId)
    const [active] = useGetHomestayisActive()
    const onChangeSearchHomestays = (e) => {
        onChangedHomestay(e)
        setHomestaySearch(e)
    }
    return (
        <Fragment>
            <Wrapper style={{ display: 'flex', marginRight: '20px' }}>
                <Select className={`form-control`}
                    value={homestaySearch}
                    onChange={(e) => onChangeSearchHomestays(e.target.value)}
                    style={{ width: '100%' }}
                >
                    <Option key={0} value=''>{defaultOptionLabel}</Option>
                    {active && active.length && active.map((homestay) => {
                        return <Option key={homestay.id} value={homestay.id}>{homestay.name}</Option>
                    })}
                </Select>
            </Wrapper>
        </Fragment>
    )
}

export default RenderHomestayisActive